











import { Vue, Component } from 'vue-property-decorator';
import { focusTabName, orderListTypes } from '@/const/order.ts';
import SearchForm from '@/components/shipping/order/SearchForm.vue';

@Component({
  components: {
    SearchForm,
  },
})
export default class OrderDeliveryIng extends Vue {
  private orderListTypes = orderListTypes.DELIVERY_ING;
  private orderSearchTypes = focusTabName.DELIVERY_TAB;
}
